module.exports = __webpack_public_path__ + "img/wfrost.21b77d7f.png";